.indented {
  padding-left: var(--spacingMd);
}

.values {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80ch;
  line-height: 1;
}

.emphasizedClassName {
  background-color: var(--paletteOrange4);
}
